<div class="location-modal modal-body">
  <!-- Modal Header -->
  <div class="modal-header">
    <span>Location-Based Messaging</span>
    <i class="fas fa-times cursor-pointer" (click)="closeModal()"></i>
  </div>

  <!-- CSV Download -->
  <div class="modal-csv">
    <span>Download user info in a CSV file</span>
    <button class="btn btn-primary" (click)="exportUserCSV()">
      <i class="fa fa-file-excel"></i>
    </button>
  </div>

  <!-- Tabs -->
  <div class="modal-tabs">
    <span class="tab" (click)="toggleUsersTab()">All Users ({{ usersFound.length }})</span>
    <i class="fa fa-envelope" style="font-size:12px; cursor: pointer" title="Send message to all users" (click)="sendMessageToAllUsers()"></i>
  </div>

  <!-- Users List -->
  @if (usersFound.length && showUsersTab) {
    <div class="scroll-list">
      <table class="user-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Organization</th>
          </tr>
        </thead>
        <tbody>
          @for (user of usersFound; track user) {
            <tr>
              <td>{{ user.name }}</td>
              <td>{{ user.companyName }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- Map -->
  <div class="map-container" id="adhocleafletmap"></div>
</div>